import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {GeneralDragAndDropComponent} from '../../General/g-drag-and-drop';
import {symbolsImages} from '../../shared/data/symbols-mockup';
import {encodingClothsImages} from '../cloths-mockup';

@Component({
  selector: 'app-generate-encoding',
  templateUrl: './generate-encoding.component.html',
  styleUrls: ['./generate-encoding.component.css']
})
export class GenerateEncodingComponent extends GeneralDragAndDropComponent implements  OnChanges {

  @Input() level: number;
  @Input() counter: number;

  encodings: number[][] = [];
  encodingSymbols: number[] = [];
  imagesToEncode: number[] = [];
  encodingLength = 3;

  ngOnChanges(changes: SimpleChanges) {

  }

  initValues() {
    super.initValues();
    this.encodings = [];
    this.encodingSymbols = [];
    this.imagesToEncode = [];
  }

  initEncoding() {
    for (let i = 0; i < this.imagesToEncode.length; i++) {
      for (let j = 0; j < this.encodingLength; j ++ ) {
        this.encodings[i][j] = -1;
      }
    }
  }

  checkSolution() {

  }

  generateNextExercise() {
    this.initValues();

    this.generateImagesToEncode();
    this.initEncoding();
    this.generateDragSymbols();
  }

  generateImagesToEncode() {
    let length = 0;
    if (this.level === 1) {
      length = 3;
    } else {
      length = 4;
    }

    while (this.imagesToEncode.length < length) {
      const randomIndex = Math.floor(Math.random() * encodingClothsImages.length);
      if (this.imagesToEncode.indexOf(randomIndex) === -1) {
        this.imagesToEncode.push(randomIndex);
      }
    }
  }

  generateDragSymbols() {
    this.encodingSymbols = [];

    let length = 0;
    if (this.level === 3) {
      length = Math.floor((Math.random() * 2) + 2);
    } else {
      length = Math.floor((Math.random() * 2) + 3);
    }

    while (this.encodingSymbols.length < length) {
      const randomIndex = Math.floor(Math.random() * symbolsImages.length);

      if (this.encodingSymbols.indexOf(randomIndex) === -1) {
        this.encodingSymbols.push(randomIndex);
      }
    }
  }

  setAllDragElementIds() {
    for (let i = 0; i < this.encodingSymbols.length; i++) {
      this.allDragElementIds.push('symbols_' + this.encodingSymbols[i].toString());
    }
  }

  getDragElementMaxSize() {
    return 8;
  }

  getImageSrc(idx: number) {
    return encodingClothsImages[idx];
  }

  getSymbolImageSrc(idx: number) {
    return symbolsImages[idx];
  }

}
